import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, map } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { Court } from "@app/core/court/domain/model/court";
import { CourtMapper } from "@app/core/court/data/network/court.mapper";
import { CourtListApiResponse } from "@app/core/shared/domain/api-types-filtered";

@Injectable({
  providedIn: "root",
})
export class GetCourtsWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(clubId: string, token: string): Observable<Court[]> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.GET_COURTS_LIST_ENDPOINT(clubId))
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.baseHandler
      .execute(parameters)
      .pipe(map((response: CourtListApiResponse) => response.courts.map(CourtMapper.deserialize)));
  }
}
